import { createApi } from "@reduxjs/toolkit/query/react";
import { apiFunction } from "./utils";
import { baseQueryWithReauth } from "./baseQueryWithReauth";

const BASE = "/api/clinic/hydration";

export const hydrationApi = createApi({
  reducerPath: "hydrationApi",
  baseQuery: baseQueryWithReauth,
  refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
  endpoints: (b) => ({
    hydrationSummary: b.mutation({ query: (d) => apiFunction(d, `${BASE}/summary`, "POST") }),
    setHydrationGoal: b.mutation({ query: (d) => apiFunction(d, `${BASE}/set-goal`, "POST") }),
  }),
});

export const { useHydrationSummaryMutation, useSetHydrationGoalMutation } = hydrationApi;
